import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';
import BaseButton from '../BaseButton';
import { outline, small } from '../BaseButton/styled';
export const IconBoxRight = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 48px;
  border-bottom: ${({
  theme
}) => `1px solid ${theme.primary.main}`};
  border-top: ${({
  theme
}) => `1px solid ${theme.primary.main}`};
  background: ${({
  theme
}) => theme.primary.main};
  color: ${({
  theme
}) => theme.primary.contrastText};
`;
export const StyledButton = styled(BaseButton)`
  ${outline};
  ${small}
  padding: 0 !important;
  text-transform: none;
  font-size: 14px;
  height: 48px;
  font-weight: 500;
  border-right: none;
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${breakpoints.md} {
    width: initial;
  }
  svg {
    width: 20px;
  }
  &:hover,
  &:focus {
    background-color: transparent;
    ${IconBoxRight} {
      border-color: ${({
  theme
}) => theme.primary.light};
      background-color: ${({
  theme
}) => theme.primary.light};
    }
  }
  &:active {
    background-color: transparent;
    ${IconBoxRight} {
      border-color: ${({
  theme
}) => theme.primary.dark};
      background: ${({
  theme
}) => theme.primary.dark};
    }
  }
`;
export const FileBoxLeft = styled.div`
  display: inline-flex;
  flex-direction: row;
  width: calc(100% - 90px);
  padding: 0 20px;
  overflow: hidden;
  text-decoration: underline;

  ::after {
    content: attr(data-filetype);
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
  }
`;
export const FileName = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  align-items: center;
`;